import React from 'react';

const MessageIcon = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.03116 8.62364C1.52182 7.67209 1.37144 6.56918 1.60745 5.516C1.84345 4.46283 2.45012 3.52956 3.31682 2.88637C4.18353 2.24318 5.25254 1.93291 6.32892 2.01215C7.4053 2.09139 8.41735 2.55485 9.18052 3.31803C9.9437 4.0812 10.4072 5.09325 10.4864 6.16963C10.5656 7.24601 10.2554 8.31502 9.61218 9.18172C8.96899 10.0484 8.03572 10.6551 6.98255 10.8911C5.92937 11.1271 4.82646 10.9767 3.87491 10.4674L2.13991 10.9774C2.05375 11.0027 1.96238 11.0043 1.87538 10.9821C1.78838 10.9599 1.70896 10.9147 1.64547 10.8512C1.58198 10.7877 1.53675 10.7083 1.51455 10.6213C1.49235 10.5343 1.49398 10.4429 1.51928 10.3568L2.03116 8.62364Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2462 5.00781C11.0021 5.04891 11.7355 5.28007 12.3784 5.67988C13.0212 6.07969 13.5529 6.63524 13.924 7.29509C14.2952 7.95494 14.4938 8.69776 14.5016 9.45479C14.5094 10.2118 14.3261 10.9586 13.9687 11.6259L14.4787 13.3609C14.504 13.4471 14.5056 13.5385 14.4834 13.6255C14.4612 13.7125 14.416 13.7919 14.3525 13.8554C14.289 13.9189 14.2096 13.9641 14.1226 13.9863C14.0356 14.0085 13.9442 14.0069 13.858 13.9816L12.1249 13.4697C11.5524 13.7759 10.9205 13.9546 10.2724 13.9937C9.62434 14.0328 8.97548 13.9313 8.37032 13.6962C7.76516 13.461 7.218 13.0978 6.76636 12.6314C6.31471 12.165 5.96925 11.6065 5.75366 10.9941"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MessageIcon;
